var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoDefferedTogo24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.099 20.1805L8.75816 19.3027L11.099 20.1805ZM13.2838 21.1665H14.0001V16.1665H13.2838V21.1665ZM36.1667 25.4998H11.5337V30.4998H36.1667V25.4998ZM11.6898 25.725L13.4398 21.0584L8.75816 19.3027L7.00816 23.9694L11.6898 25.725ZM11.5337 25.4998C11.55 25.4998 11.5821 25.5055 11.6147 25.5231C11.6427 25.5383 11.6601 25.5562 11.6707 25.5716C11.6814 25.5869 11.692 25.6095 11.6964 25.6411C11.7015 25.6777 11.6955 25.7099 11.6898 25.725L7.00816 23.9694C5.82324 27.1292 8.15909 30.4998 11.5337 30.4998V25.4998ZM13.2838 16.1665C11.269 16.1665 9.46559 17.4163 8.75816 19.3027L13.4398 21.0584C13.4154 21.1234 13.3532 21.1665 13.2838 21.1665V16.1665Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.667 4.6665C35.0004 6.99984 30.3337 9.33317 32.667 11.6665",
    stroke: "currentColor",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0068 4.6665C26.3402 6.99984 21.6735 9.33317 24.0068 11.6665",
    stroke: "currentColor",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 21.1663H36.3935L32.9256 33.8821C34.5428 31.6135 36.8198 29.8478 39.4765 28.8651L41.5761 21.1663H42.4238L44.2875 27.9997C44.3027 27.9997 44.318 27.9997 44.3333 27.9997C46.2608 27.9997 48.0973 28.3892 49.7685 29.0938L47.2141 19.7279C46.6406 17.6251 44.7307 16.1663 42.5511 16.1663H39.6666H14V21.1663ZM31.19 46.833C30.6359 45.3265 30.3333 43.6984 30.3333 41.9997C30.3333 41.944 30.3336 41.8885 30.3343 41.833H10.3143L14.0704 28.6865L9.26282 27.3129L5.44597 40.6719C4.56379 43.7595 6.88216 46.833 10.0933 46.833H31.19Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.6569 41.995C53.6569 47.1469 49.4804 51.3234 44.3285 51.3234C39.1765 51.3234 35 47.1469 35 41.995C35 36.843 39.1765 32.6665 44.3285 32.6665C49.4804 32.6665 53.6569 36.843 53.6569 41.995ZM42 35H44.3315V42H47.8447V44.3284H42V43.1737V42V35Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDefferedTogo24);
export default __webpack_public_path__ + "static/media/ico-deffered_togo-24.5ced085c.svg";
export { ForwardRef as ReactComponent };